import CogIcon from "@/assets/icons/svg/Cog/CogOutlined.svg?react";
import { useClientConfig } from "@/features/client-config/contexts/client-config/use-client-config";
import { useTranslate } from "@/hooks/use-translate";
import clsx from "clsx";
import React from "react";

import styles from "./KioskLockOverlay.module.css";

export const KioskLockOverlay: React.FC = () => {
  const { clientConfig, isLoading } = useClientConfig();
  const { t } = useTranslate();

  const isLocked = Boolean(clientConfig?.kioskLockEnabled);

  // A persisted lock is unknown until config loads, so cover the app meanwhile.
  if (!isLocked && !isLoading) {
    return null;
  }

  return (
    <div
      className={clsx(styles.overlay, !isLocked && styles.pending)}
      role={isLocked ? "alertdialog" : undefined}
      aria-modal={isLocked ? "true" : undefined}
      aria-label={isLocked ? t("kiosk-lock.title") : undefined}
    >
      {isLocked && (
        <>
          <CogIcon className={styles.icon} aria-hidden="true" />
          <p className={styles.title}>{t("kiosk-lock.title")}</p>
          <img src="/assets/logo.svg" alt="Trackman" className={styles.logo} />
        </>
      )}
    </div>
  );
};
